import { useEffect } from "react";

// Reveal .bye-fadeup elements on scroll. Re-runs when `dep` changes (route change).
export const useReveal = (dep) => {
    useEffect(() => {
        const els = document.querySelectorAll(".bye-fadeup:not(.is-visible)");
        const obs = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("is-visible");
                        obs.unobserve(e.target);
                    }
                });
            },
            { threshold: 0.12 },
        );
        els.forEach((el) => obs.observe(el));
        return () => obs.disconnect();
    }, [dep]);
};
